import React from 'react';
import { IconButton, Typography, List, ListItem, ListItemText, ListItemSecondaryAction } from '@mui/material';
import { IEmail } from './types';
import { DeleteOutlineOutlined } from '@mui/icons-material';


interface IProps{
  emails: IEmail[],
  onDelete:(email:IEmail) => void;
}

export default function EmailsList(props:IProps) {

  if(!props.emails.length){
    return (
      <Typography color="textSecondary" align="center">Адреси відсутні</Typography>
    )
  }

  return (
    <List>
        { props.emails.map((email:IEmail) => {
          return (
            <ListItem key={email.id}>
              <ListItemText
                primary={email.email}
              />
              <ListItemSecondaryAction>
                <IconButton edge="end"
                  onClick={(e)=>{
                    e.preventDefault();
                    props.onDelete(email);
                  }}
                >
                  <DeleteOutlineOutlined />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          )
        })}
    </List>
  );
}